// extracted by mini-css-extract-plugin
module.exports = {"options":"ShopifyCustomOnboarding_options__35bRY","option":"ShopifyCustomOnboarding_option__2qyUw","active":"ShopifyCustomOnboarding_active__16g56"};